var $ = require('jquery')
  , getDownloadInfo = require('mobile/common-components/components/getDownloadInfo.js')
  , tmpl = require('./tmpl.handlebars')

module.exports = function(container) {
  var section = container.find('.mod-mater-quick-channel')

  $.when(getDownloadInfo()).then(function(res) {
    if (res.url) {
      if (section.find('a').length === 2) {
        section.find('a:last').replaceWith(tmpl(res))
      } else {
        section.html(tmpl(res))
      }
    }
  })
}